module.exports = __webpack_public_path__ + "static/media/banner-js.d0ff98ba.png";